import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "semanticColor", "condensed", "condensedAll", "iconLeading", "iconTrailing", "iconOnly", "buttonSize", "iconSize", "hover", "active", "focus", "isUsingKeyboard", "useBrowserDefaultFocusStyle", "status"];
import React from 'react';
import { buttonStylesActive, buttonStylesBase, buttonStylesDisabled, buttonStylesHover, buttonWithIconSidePadding, controlPaddingBlock, controlSizeFallback, cssColorValue, cssControlSize, cssSpacing, focusBorderWidth, focusBottomBorder, getIconNumeric, getIconPlacement, getTertiaryButtonPadding, overflowWrapFlexText, semanticColors, slControlSize } from "../../styles/index.mjs";
import { pxToInt } from "../../typeHelpers.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Button = styled( /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'button' : _ref$component,
    semanticColor = _ref.semanticColor,
    condensed = _ref.condensed,
    condensedAll = _ref.condensedAll,
    iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    iconOnly = _ref.iconOnly,
    buttonSize = _ref.buttonSize,
    iconSize = _ref.iconSize,
    hover = _ref.hover,
    active = _ref.active,
    focus = _ref.focus,
    isUsingKeyboard = _ref.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref.useBrowserDefaultFocusStyle,
    status = _ref.status,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Button",
  componentId: "sc-1dqy6lx-0"
})(["", ""], function (_ref2) {
  var buttonSize = _ref2.buttonSize,
    _ref2$semanticColor = _ref2.semanticColor,
    semanticColor = _ref2$semanticColor === void 0 ? 'textSubdued' : _ref2$semanticColor,
    hover = _ref2.hover,
    active = _ref2.active,
    focus = _ref2.focus,
    useBrowserDefaultFocusStyle = _ref2.useBrowserDefaultFocusStyle,
    status = _ref2.status,
    isUsingKeyboard = _ref2.isUsingKeyboard,
    condensed = _ref2.condensed,
    condensedAll = _ref2.condensedAll,
    iconLeading = _ref2.iconLeading,
    iconTrailing = _ref2.iconTrailing,
    iconOnly = _ref2.iconOnly,
    iconSize = _ref2.iconSize;
  var getPaddingInline = function getPaddingInline() {
    switch (buttonSize) {
      case 'small':
        return cssSpacing('base', '16px');
      case 'large':
        return cssSpacing('looser-3', '48px');
      default:
        return cssSpacing('looser-2', '32px');
    }
  };
  var withIconPaddingLeftRight = buttonWithIconSidePadding(buttonSize);
  var iconPlacement = getIconPlacement({
    iconOnly: iconOnly,
    iconLeading: iconLeading,
    iconTrailing: iconTrailing
  });
  var padding = getTertiaryButtonPadding({
    buttonSize: buttonSize,
    status: status,
    iconPlacement: iconPlacement,
    condensed: condensed,
    condensedAll: condensedAll
  });
  var hoverStyles = css(["", " ", ""], buttonStylesHover, semanticColor === 'textSubdued' && css(["color:", ";"], cssColorValue(semanticColors.textBase)));
  var activeStyles = css(["", " color:", ";"], buttonStylesActive, cssColorValue(semanticColor));
  var disabledStyles = css(["", " color:", ";&::before{background-color:transparent;}&::after{border-color:transparent;}"], buttonStylesDisabled, cssColorValue(semanticColor));
  var focusStyles = function focusStyles() {
    var focusBorderBase = (condensedAll ? 0 : pxToInt(controlPaddingBlock[buttonSize])) + focusBorderWidth;
    var getFocusBorderLength = function getFocusBorderLength() {
      if (iconOnly) return "".concat(getIconNumeric(iconSize), "px");
      if (condensed || condensedAll) return "100%";
      if (iconLeading || iconTrailing) return "calc(100% - (".concat(withIconPaddingLeftRight, " * 2));");
      return "calc(100% - (".concat(getPaddingInline(), " * 2))");
    };
    return css(["", ";&::after{inline-size:", ";}"], !useBrowserDefaultFocusStyle && focusBottomBorder(focusBorderBase, isUsingKeyboard, focus), getFocusBorderLength());
  };
  return css(["", " color:", ";min-inline-size:0;", ";", " ", ";display:inline-flex;align-items:center;justify-content:center;&:hover{", "}", " &:active{", "}", " ", " &[disabled],&[aria-disabled='true'],fieldset[disabled] &{", "}"], buttonStylesBase(buttonSize, useBrowserDefaultFocusStyle, status), cssColorValue(semanticColor), overflowWrapFlexText(), !condensedAll && css(["min-block-size:", ";"], cssControlSize(slControlSize(buttonSize), controlSizeFallback[buttonSize])), padding, hoverStyles, hover && hoverStyles, activeStyles, active && activeStyles, focusStyles, disabledStyles);
});